// extracted by mini-css-extract-plugin
module.exports = {"root":"koluserlayout_root_DeDDB","user":"koluserlayout_user_3LnM6","main":"koluserlayout_main_EOoZn"};